<template>
  <div class="comp-agency-tree-detail">
    <div class="title">
      选择门店
      <span class="close" @click="handleClose">✕</span>
    </div>
    <div class="content">
      <el-form :model="form" label-width="100px">
        <el-form-item label="品牌：">
          <a href="javascript:;" class="select-item" :class="{active:form.brand === 'all'}"
             @click="handleSelectAllBrand">全部</a>
          <a
            v-for="item in brands"
            href="javascript:;"
            class="select-item"
            :class="{active:item.id === form.brand}"
            @click="handleBrandClick(item)">{{item.name}}</a>
        </el-form-item>
        <el-form-item label="经营方式：">
          <a
            v-for="item in manageWays"
            href="javascript:;"
            class="select-item"
            :class="{active:item.id === form.manageWay}"
            @click="handleWayClick(item)">{{item.name}}</a>
        </el-form-item>
        <el-form-item label="城市区域：">
          <a href="javascript:;" class="select-item" :class="{active:form.area === 'all'}"
             @click="handleSelectAllArea">全部</a>
          <a
            :key="index"
            v-for="(item,index) in provinces"
            href="javascript:;"
            class="select-item"
            :class="{active:item.active}"
            @click="handleSelectProv(item)">
            {{`${item.name}(${item.children.filter((item) => {return item.active;}).length})`}}</a>
          <div class="city-container" v-if="this.form.area !== 'all'">
            <a
              :key="index"
              v-for="(city,index) in form.province.children"
              class="select-item"
              :class="{active:city.active}"
              @click="handleSelectCity(city)"
              href="javascript:void(0);">{{city.name}}</a>
          </div>
        </el-form-item>
        <el-form-item label="经营门店：">
          <div class="panel">
            <div class="panel-heading">
              已选 {{this.selectList.length}} 家
              <span class="clear-btn" @click="handleClear">清空</span>
            </div>
            <div class="panel-body">
              <AgencyTreeCore
                :checkable="checkable"
                className="detail"
                @checkAgencyLeaves="checkAgencyLeaves"
                @nodeClick="handleNodeClick"
                @filter="handleFilter"
                :content-height="280"
                ref="tree"
                :has-show-more-btn="false"
                :treeData="treeData"
                :filter-node-method="handleFilterNode"></AgencyTreeCore>
            </div>
          </div>
        </el-form-item>
        <div class="btn-area">
          <el-button class="reset-btn" @click="handleReset" size="small">重置</el-button>
          <el-button type="primary" class="save-btn" @click="handleConfirm" size="small">确认</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import AgencyTreeCore from './AgencyTreeCore';

  const zhiXia = ['北京市', '天津市', '上海市', '重庆市'];

  export default {
    props: {
      'treeData': {
        type: Array,
        default: []
      },
      'loadBrand': {
        type: Function,
        default: () => {
          return global.vm.$axios.post('/fork', [{
            key: "brand",
            url: "/hq-agency/label/drop_down?type=brand"
          }]).then((res) => {
            return res.brand.data;
          });
        }
      },
      'checkable': {
        type: Boolean,
        default: true
      }
    },
    components: {
      AgencyTreeCore
    },
    data () {
      const provinces = [];
      const map = {};
      this.treeData.forEach((data) => {
        const {province, city, country} = data;
        if (province) {
          if (!map[province]) {
            map[province] = {};
          }
          if (zhiXia.indexOf(province) !== -1 && country !== '') {
            map[province][country] = country;
          } else if (city !== '') {
            map[province][city] = city;
          }
        }
      });
      for (let i in map) {
        provinces.push({
          name: i,
          children: Object.keys(map[i]).map((item) => {
            return {
              name: item,
              active: true
            };
          })
        });
      }
      return {
        form: {
          manageWay: '',
          area: 'all',
          province: {},
          brand: 'all'
        },
        visible: false,
        provinces: provinces,
        brands: [],
        orgByBrand: {},
        selectList: [],
        manageWays: [
          {id: '', name: '全部'},
          {id: 0, name: '直营'},
          {id: 1, name: '加盟'}
        ],
      };
    },
    created () {
      this.loadBrand().then((res) => {
        this.brands = res;
      });
    },
    methods: {
      checkAgencyLeaves (datas) {
        this.selectList = datas.filter((item) => {
          return item.checkStatus.checked === 2 && this.handleFilterNode(item) && item.visible === true && item.type === 3;
        });
      },
      handleFilter () {
        this.checkAgencyLeaves(this.treeData);
      },
      handleFilterNode (data, filterText) {
        let flag = false;
        if (JSON.stringify(this.form.province) === '{}') {
          flag = true;
        } else {
          for (let i = 0, length = this.provinces.length; i < length; i++) {
            if (data.type === 3 && this.provinces[i].name === data.province) {
              flag = !!this.provinces[i].children.filter((city) => {
                return (city.name === data.city || city.name === data.country) && city.active === true;
              }).length;
            }
          }
        }
        if (filterText && data.name.indexOf(filterText) === -1) {
          flag = false;
        }
        const ret = flag
          && (this.form.brand === 'all' || this.orgByBrand[this.form.brand].indexOf(data.id) !== -1 )
          && (this.form.manageWay === '' || this.form.manageWay === data.attribute);
        return ret;
      },
      handleDelSelect (index) {
        this.selectList.splice(index, 1);
        const ids = this.selectList.map((item) => {
          return item.id;
        });
        this.$refs.tree.setAgency(ids);
      },
      handleClear () {
        this.$refs.tree.clear();
        this.selectList = [];
      },
      handleConfirm () {
        if (this.selectList.length === 0) {
          this.$message.warning('请选择门店');
          return false;
        }
        const agencies = this.selectList.map((item) => {
          return item.id;
        });
        this.$emit('confirm', agencies);
      },
      handleReset () {
        this.show(this.oldValue);
      },
      show (agencies) {
        this.provinces.forEach((prov) => {
          prov.active = false;
          prov.children.forEach((city) => {
            city.active = true;
          });
        });
        this.form = {
          manageWay: '',
          area: 'all',
          province: {},
          brand: 'all'
        };
        const oldValue = [];
        this.selectList = this.treeData.filter((item) => {
          item.expanded = true;
          item.visible = true;
          const flag = agencies.indexOf(item.id) !== -1 && item.type === 3;
          if (flag) {
            oldValue.push(item.id);
          }
          return flag;
        });
        this.$refs.tree.clearFilter();
        this.$refs.tree.caclHeight();
        this.$refs.tree.setAgency(agencies);
        if (!this.oldValue) {
          this.oldValue = oldValue;
        }
      },
      handleSelectAllArea () {
        this.form.area = 'all';
        this.form.province = {};
        this.provinces.forEach((item) => {
          item.active = false;
          item.children.forEach((city) => {
            city.active = true;
          });
        });
        this.$refs.tree.handleFilter();
        this.checkAgencyLeaves(this.treeData);
      },
      handleSelectAllBrand (item) {
        this.form.brand = 'all';
        this.$refs.tree.handleFilter();
        this.checkAgencyLeaves(this.treeData);
      },
      handleBrandClick (item) {
        this.form.brand = item.id;
        if (this.orgByBrand[item.id]) {
          this.$refs.tree.handleFilter();
          this.checkAgencyLeaves(this.treeData);
        } else {
          this.$axios.get(`/hq-agency/agency/list?brandId=${item.id}`).then((res) => {
            this.orgByBrand[item.id] = res.data.map((i) => {
              return i.id;
            });
            this.$refs.tree.handleFilter();
            this.checkAgencyLeaves(this.treeData);
          });
        }
      },
      handleSelectProv (item) {
        this.form.area = 'not-all';
        this.provinces.forEach((prov) => {
          if (prov.name === item.name) {
            prov.active = true;
            this.form.province = item;
          } else {
            prov.active = false;
          }
          return prov;
        });
        this.$refs.tree.handleFilter();
        this.checkAgencyLeaves(this.treeData);
      },
      handleSelectCity (city) {
        city.active = !city.active;
        this.$refs.tree.handleFilter();
        this.checkAgencyLeaves(this.treeData);
      },
      handleWayClick (way) {
        this.form.manageWay = way.id;
        this.$refs.tree.handleFilter();
        this.checkAgencyLeaves(this.treeData);
      },
      handleClose () {
        this.$emit('close', this.oldValue);
      },
      handleNodeClick (agency) {
        if (this.checkable) {
          this.selectList = [agency];
        } else {
          this.selectList = [agency].filter(item => item.type === 3);
          if (this.selectList.length > 0) {
            const agencies = this.selectList.map((item) => {
              return item.id;
            });
            this.$emit('confirm', agencies);
          }
        }
      }
    }
  };
</script>

<style lang="less">
  .comp-agency-tree-detail {
    .title {
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
      border-bottom: 1px solid #ebeef5;
      .close {
        float: right;
        margin-right: 20px;
        cursor: pointer
      }
    }
    .content {
      padding: 0 20px 10px 20px !important;
      .city-container {
        border: 1px solid #ddd;
        padding: 3px 5px;
        a {
          padding: 3px;
          color: #333;
        }
        a.active {
          color: #016cdf;
        }
      }
      .del-btn {
        float: right;
      }
      .select-item {
        text-decoration: none;
        font-size: 12px;
        color: #333333;
        letter-spacing: -0.29px;
        margin-left: 20px;
        cursor: pointer;
      }
      .select-item.active {
        color: #016cdf;
      }
      .el-form-item {
        margin-bottom: 2px !important;
      }
      .el-form-item__label {
        line-height: 26px !important;
      }
      .el-form-item__content {
        line-height: 25px !important;
      }
      .select-btn {
        display: inline-block;
        min-width: 30px;
        width: 30px;
        height: 30px;
        background: #016cdf;
        border-radius: 2px;
        border: 1px solid #d8d8d8;
        color: white;
        cursor: pointer;
        margin-top: 135px;
        span {
          margin-left: -6px;
        }
      }
      .panel {
        margin-top: 5px;
        display: inline-block;
        margin-bottom: 20px;
        background-color: #fff;
        border-radius: 4px;
        -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
        box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
        width: 240px;
        vertical-align: top;
      }
      .panel-heading {
        font-size: 13px;
        color: #FFFFFF;
        letter-spacing: -0.29px;
        background: rgba(1, 108, 223, 0.80);
        border-color: #ddd;
        line-height: 22px;
        height: 22px;
        padding: 4px 0 4px 14px;
        .clear-btn {
          float: right;
          cursor: pointer;
          padding: 0 20px;
        }
      }
      .panel-body {
        border: 1px solid #ddd;
        max-height: 325px !important;
        overflow-y: hidden;
      }
      .select-container {
        border: 1px solid #ddd;
        height: 270px;
        padding: 8px;
        overflow-y: auto;
      }
      .btn-area {
        text-align: center;
      }
      .el-tree-node__label {
        width: 160px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AgencyTreeDetail.vue?a42bc806